<template>
  <div class="vue-horizontal-timeline" :style="setTimelineStyles">
    <section class="timeline" id="scrollBoxTime">
      <vue-seamless-scroll :data="items" :class-option="optionLeft">
        <ol>
          <li
            v-for="(item, i) in items"
            :key="i"
            :style="setLineColor"
            :class="[
              { 'add-step': hasSlot || item[titleAttr] || item[contentAttr] },
              item.stepCssClass,
            ]"
          >
            <div
              v-if="hasSlot || item[titleAttr] || item[contentAttr]"
              class="time"
              :class="[getTimeClass(item), item.boxCssClass]"
              @click="cardClicked(item)"
            >
              <slot v-if="hasSlot" v-bind:item="item" v-bind:index="i" />
              <span
                class="title"
                v-if="!hasSlot && item[titleAttr]"
                :class="getTitleClasses"
              >
                {{ textSubstr(item[titleAttr], titleSubstr) }}
              </span>
              <span
                class="content"
                v-if="!hasSlot && item[contentAttr]"
                :class="getContentClasses"
              >
                {{ textSubstr(item[contentAttr], contentSubstr) }}
              </span>
              <span class="time_span" :class="getContentClasses">
                {{ item.date ? moment(item.date).format("YYYY-MM") : "" }}
              </span>
              <div class="icon_origin"></div>
            </div>
          </li>
          <li :style="setLineColor"></li>
        </ol>
      </vue-seamless-scroll>
    </section>
  </div>
</template>

<script>
import * as moment from "moment";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "VueHorizontalTimeline",
  data() {
    return {
      moment,
    };
  },
  components: {
    vueSeamlessScroll,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemSelected: {
      type: Object,
      default: () => ({}),
    },
    itemUniqueKey: {
      type: String,
      default: "",
    },
    titleAttr: {
      type: String,
      default: "title",
    },
    titleCentered: {
      type: Boolean,
      default: false,
    },
    titleClass: {
      type: String,
      default: "",
    },
    titleSubstr: {
      type: Number,
      default: 18,
    },
    contentAttr: {
      type: String,
      default: "subTitle",
    },
    time_span: {
      type: String,
      default: "date",
    },
    contentCentered: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: "",
    },
    contentSubstr: {
      type: Number,
      default: 250,
    },
    minWidth: {
      type: String,
      default: "200px",
    },
    minHeight: {
      type: String,
      default: "",
    },
    timelinePadding: {
      type: String,
      default: "",
    },
    timelineBackground: {
      type: String,
      default: "",
    },
    lineColor: {
      type: String,
      default: "rgba(151, 151, 151, 0.45)",
    },
    clickable: {
      type: [String, Boolean],
      default: true,
    },
  },
  emits: ["click", "update:itemSelected"],
  computed: {
    optionLeft() {
      return {
        step: 1,
        direction: 2, // 0向下 1向上 2向左 3向右
        // limitMoveNum: this.items.length,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        openTouch: false,
      };
    },
    hasSlot() {
      return "$scopedSlots" in this && this.$scopedSlots?.default
        ? true
        : !!this.$slots?.default;
    },
    setTimelineStyles() {
      const { timelineBackground, timelinePadding } = this;
      const styleObj = {};
      if (timelinePadding) {
        styleObj.padding = timelinePadding;
      }
      if (timelineBackground) {
        styleObj.background = timelineBackground;
      }
      return styleObj;
    },
    setLineColor() {
      const { lineColor } = this;
      return lineColor ? `background: ${lineColor}` : "";
    },
    /*  getTimeStyles() {
      const { minWidth, minHeight, clickable } = this;
      const styleObj = {
        minWidth,
        minHeight,
      };
      if (!clickable) {
        styleObj.cursor = "default";
      }
      return styleObj;
    }, */
    getTitleClasses() {
      const { titleClass, titleCentered } = this;
      return titleClass || { "text-center": titleCentered };
    },
    getContentClasses() {
      const { contentClass, contentCentered } = this;
      return contentClass || { "text-center": contentCentered };
    },
  },
  methods: {
    textSubstr(value, qtd = 250, mask = "...") {
      return value;
    },
    cardClicked(item) {
      if (!this.clickable) {
        return;
      }
      this.$emit("update:itemSelected", { ...item });
      this.$emit("click", item);
    },
    getTimeClass(item) {
      const { itemUniqueKey, itemSelected } = this;
      if (itemUniqueKey && itemSelected) {
        return {
          "border-blue": item[itemUniqueKey] === itemSelected[itemUniqueKey],
        };
      }
      return {};
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes triangle-odd {
  100% {
    filter: drop-shadow(4px 2px 1px rgba(0, 0, 0, 0.2))
      drop-shadow(2px 4px 0px rgba(0, 0, 0, 0.14));
  }
}
@keyframes triangle-even {
  100% {
    filter: drop-shadow(4px -1px 1px rgba(0, 0, 0, 0.2));
  }
}
.vue-horizontal-timeline {
  position: relative;
  width: 100%;
  .text-center {
    text-align: center;
  }
  .timeline {
    white-space: nowrap;
    overflow-x: auto;
    padding: 0 0;
    height: inherit;
    scrollbar-width: thin;
    scrollbar-color: rgba(155, 155, 155, 0.7) rgba(255, 255, 255, 0.5);
    margin: 0 158px 0 148px;
    overflow: hidden;
    .title {
      display: block;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 10px;
      white-space: normal;
      font-family: "PingFang_Medium";
    }
    .content {
      display: block;
      font-size: 24px;
      margin-bottom: 10px;
      // overflow: hidden;
      width: 260px;
    }
    .time_span {
      display: block;
      font-size: 24px;
      margin-bottom: 10px;
      font-size: 24px;
      color: #000000;
      opacity: 0.5;
    }
    .icon_origin {
      width: 43px;
      height: 9px;
      background: #f7931e;
      border-radius: 5px;
    }
    ol {
      box-sizing:border-box;
      font-size: 0;
      width: 100%;
      padding: 280px 0 280px 0px;
      height: 500px;
      transition: all 0.5s;
      li {
        position: relative;
        display: inline-block;
        list-style-type: none;
        width: 200px;
        height: 1px;
        background: #979797;
        &:last-child {
          width: 200px;
        }
        &.add-step:not(:last-child) {
          padding-right: 0px;
          margin-right: 0px;
          &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: calc(100% - 140px);
            bottom: 0;
            width: 9px;
            height: 9px;
            transform: translateY(-50%);
            border-radius: 50%;
            background: #f7931e;
            border: 1px solid #fff;
          }
        }
        .time {
          position: absolute;
          left: 1.6em;
          padding: 20px 10px;
          font-size: 24px;
          // white-space: normal;
          color: black;
          transition: 0.2s all ease-out;
          width: 248px;
          cursor: pointer;
        }
        &:nth-child(1) {
          .title {
            font-size: 40px;
          }
        }
        &:nth-child(even) {
          .time {
            top: calc(100% + 58px);
            &::before {
              top: -58px;
            }
            &:hover {
              &::before {
                animation: triangle-even 0.2s both;
              }
            }
          }
          .time.border-blue {
            filter: drop-shadow(-1px 0px 0 #979797)
              drop-shadow(1px 1px 0 #979797) drop-shadow(0px -1px 0 #979797);
          }
        }
        &:nth-child(odd) {
          .time {
            top: -58px;
            transform: translateY(-100%);
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-top-left-radius: 3px;
            &::before {
              top: 100%;
              border-width: 8px 8px 0 0;
              border-color: white transparent transparent transparent;
              filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.2))
                drop-shadow(1px 1px 0px rgba(0, 0, 0, 0.14));
            }
            &:hover {
              &::before {
                animation: triangle-odd 0.2s both;
              }
            }
          }
          .time.border-blue {
            filter: drop-shadow(-1px 0px 0 #979797)
              drop-shadow(1px 1px 0 #979797) drop-shadow(0px -1px 0 #979797);
          }
        }
      }
    }
  }
}
.timeline::-webkit-scrollbar {
  height: 6px;
}

.timeline::-webkit-scrollbar-thumb {
  background-color: rgba(155, 155, 155, 0.7);
  border-radius: 3px;
}
</style>
